import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import ModalHome from "../pages/components/ModalHome";

export default function ModalTimer() {
    const [openModalHome, setOpenModalHome] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // Não executa nas páginas de nicho
        if (
            location.pathname !== "/nichos" &&
            location.pathname.startsWith("/nichos/")
        ) {
            return;
        }

        const jaAbriu = sessionStorage.getItem("modal-contblack");

        if (jaAbriu) return;

        const timer = setTimeout(() => {
            setOpenModalHome(true);
            sessionStorage.setItem("modal-contblack", "true");
        }, 45000);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    // Não renderiza o modal nas páginas de nicho
    if (
        location.pathname !== "/nichos" &&
        location.pathname.startsWith("/nichos/")
    ) {
        return null;
    }

    return (
        <ModalHome
            openModalHome={openModalHome}
            setOpenModalHome={setOpenModalHome}
        />
    );
}